// 管理用户数据相关

import { defineStore } from "pinia";
import { ref } from "vue";

// import { loginAPI } from '@/apis/user'
export const useUserStore = defineStore(
  "user",
  () => {
    // 1. 定义管理用户数据的state
    const token = ref("");
    const userInfo = ref({});
    // 2. 定义获取接口数据的action函数

    const channel = ref(""); // 渠道

    const characterInfo = ref({});
    // const seqId = ref(0); //请求历史数据的消息起始id
    const header = ref({});
    // 退出时清除用户信息
    const clearUserInfo = () => {
      console.log("清除用户信息");
      // userInfo.value = {};
      // characterInfo.value = {};
      // token.value = "";
      header.value = {};
      // seqId.value = 0;
    };
    return {
      token,
      header,
      channel,
      // seqId,
      userInfo,
      characterInfo,
      clearUserInfo,
    };
  },
  {
    persist: {
      enabled: true, //开启数据持久化
      strategies: [
        {
          key: "figure", //给一个要保存的名称
          storage: localStorage, //sessionStorage / localStorage 存储方式
        },
      ],
    },
  }
);
